<!-- <p>
  drzava-modal works!
</p> -->
<!-- <div class="row">
  <div class="col-md-12">
    <h1>
      <span>Početna > Države</span></h1> -->
      <!-- <yt-breadcrumbs></yt-breadcrumbs> -->
  <!-- </div>
</div> -->
<div class="row">
  <div class="col-md-12">
      <!-- <div class="col-lg-2 col-md-3 col-3 input-group-append pl-0 justify-content-end"> -->
    <div class="col-lg-2 col-md-3 col-3 pull-right">
      <span class="input-group-append">
          <button type="button" class="btn btn-secondary" ngbTooltip="Preuzmi podatke o državama" placement="top" container="body" (click)="GetCountryData()" ><span class="fa fa-fw fa-download"></span></button>
      </span>
  </div>
  </div>
</div>
<div class="row">
  <div class="col-lg-12 col-md-12 col-12">
    <yt-fw-default-list-modal [CondensedTable]="true" #defaultList></yt-fw-default-list-modal>
  </div>
 
</div>